/** Loaders can throw an error with this message to cause the standard 404 page to be displayed. */
export const NotFoundRoutingErrorMessage = "404NotFoundRoutingError";
export const NetworkErrorMessage = "NetworkError";
export const Routing500ErrorMessage = "500Error";
export const Routing401ErrorMessage = "401Error";
export const Routing403ErrorMessage = "403Error";
